// src/components/RightPanel/History/SnapshotViewer.jsx
import React, { useRef, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  useTheme
} from '@mui/material';

const SnapshotViewer = ({ content }) => {
  const theme = useTheme();
  const containerRef = useRef(null);

  useEffect(() => {
    // Only attempt to render HTML if we're not in raw mode and have content
    if (content && containerRef.current) {
      // Clear previous content
      containerRef.current.innerHTML = '';
      
      try {
        // Create an iframe to safely render the HTML
        const iframe = document.createElement('iframe');
        iframe.style.width = '100%';
        iframe.style.height = '500px';
        iframe.style.border = 'none';
        
        containerRef.current.appendChild(iframe);
        
        // Access the iframe's document and write the HTML content
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        // Inject dark mode styles if theme is dark
        if (theme.palette.mode === 'dark') {
          const darkStyles = `<style>
            html, body {
              background-color: #1e1e1e !important;
              color: #e8e8e8 !important;
            }
            * { color: inherit; }
            h1, h2, h3, h4, h5 { color: #f0f0f0 !important; }
            p { color: #d4d4d4 !important; }
            a { color: #60a5fa !important; }
          </style>`;
          iframeDoc.write(darkStyles + content);
        } else {
          iframeDoc.write(content);
        }
        iframeDoc.close();
        
        // Adjust iframe height based on content
        iframe.onload = () => {
          const height = iframeDoc.body.scrollHeight;
          iframe.style.height = `${height + 20}px`;
        };
      } catch (error) {
        console.error('Error rendering HTML:', error);
        containerRef.current.innerHTML = '<div style="color: red;">Error rendering HTML content</div>';
      }
    }
  }, [content]);

  if (!content) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="text.secondary">No content snapshot available</Typography>
      </Box>
    );
  }

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1
      }}
    >
      <Box ref={containerRef} />
    </Paper>
  );
};

export default SnapshotViewer;